import { Component, OnInit } from '@angular/core';
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Router} from "@angular/router";
import {Observable} from "rxjs";
import {EmployeeService} from "../../../../services/employee.service";

@Component({
  selector: 'app-progress-table',
  templateUrl: './progress-table.component.html',
  styleUrls: ['./progress-table.component.scss']
})
export class ProgressTableComponent implements OnInit {
  displayedColumns=['sr','childName','totalSessions','from','to','createdAt','submittedBy','actions']
  dataSource: any[] = []; // Data source for the table
  counsellors$:Observable<any>
  constructor(private mFirestore: AngularFirestore,
              private mSnackbar:MatSnackBar,
              private readonly  mEmployeeService:EmployeeService,
              private mRouter:Router) {
    this.counsellors$ = this.mEmployeeService.getCounsellers()
  }

  ngOnInit(): void {

  }

  addReport() {
    this.mRouter.navigateByUrl('home/reports/progress-table')
  }

  ViewReport(id:any) {

  }

  deleteReport(id:any) {

  }

  formatTimestamp(createdAt: number): string {
    const date = new Date(createdAt);

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
    const day = date.getDate().toString().padStart(2, '0');

    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  }


}
